/**
 * Esta instalacao tem FeedDrive? (11/09/2026)
 *
 * No GNC DESK o FeedDrive nunca existiu (`FEEDDRIVE_ENABLED=false`), e o menu
 * levava a uma tela que disparava 9 consultas e 9 alarmes vermelhos de "servico
 * externo nao respondeu". A resposta vem do backend, da mesma configuracao que o
 * adaptador le — nao de flag de build: ligar o FeedDrive e trocar a variavel e
 * reiniciar, sem rebuildar a imagem do front.
 */
import { useQuery } from '@tanstack/react-query';

import { api } from '@/services/api';

export type FeedDriveEstado = { habilitado: boolean };

export function useFeedDriveEstado() {
  return useQuery({
    queryKey: ['feeddrive', 'estado'],
    queryFn: () => api.get<FeedDriveEstado>('/feeddrive/estado'),
    // Muda so com redeploy: perguntar uma vez por sessao basta.
    staleTime: Infinity,
    retry: false,
  });
}

/** `true` so quando o backend disse que sim: sem resposta, a porta fica fechada. */
export function useFeedDriveHabilitado(): boolean {
  return useFeedDriveEstado().data?.habilitado === true;
}
